import { BRAND_LIST, CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_AU_UQ || "uq.au.new-styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_AU_UQ || 27493,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_AU_UQ || 27494,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_AU_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_AU_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_AU_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_AU_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.EN],
  countryRegion: "Australia/Canberra",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "AEST",
      offset: {
        AEST: 10,
        AEDT: 11
      }
    }
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>"
  },
  requireDecimal: true,
  privacyPolicyUrl: {
    [BRAND_LIST.UQ]: {
      [LANGUAGE.EN]:
        "https://faq-au.uniqlo.com/pkb_Home?id=kA0Ie000000TORV&l=en_US&fs=Search&pn=1"
    }
  },
  termsOfUseUrl: {
    [BRAND_LIST.UQ]: {
      [LANGUAGE.EN]:
        "https://faq-au.uniqlo.com/pkb_Home?l=en_US&c=category_uq%3AUQAU_C7_1"
    }
  }
};

export default _countryEnv;
